import Lottie from 'lottie-react';
import santa from "../../assets/images/lottieJSON/Merry Christmas.json"

const MerryChristmas = () => {
    return (

        <div className='absolute   xl:-mt-36 lg:-mt-44 -mt-24'>
            <div className=" w-32 h-32 lg:w-44 lg:h-44  ">
                <Lottie
                    animationData={santa}
                    loop={true}
                    autoplay={true}
                    className="w-full h-full"
                />
            </div>
        </div>
    )
}

export default MerryChristmas